<template>
  <div class="customer">
    <div class="banner">
      <div class="banner-center center">
        <div class="banner-info">
          <div class="btn shenqing bgRed" @click="openDialog('免费试用', 0)">
            申请试用
          </div>
        </div>
      </div>
    </div>
    <div class="item_1">
      <div class="item-title">
        <h3 class="title2">校长寄语</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li
            v-for="x in item1_list"
            :class="{ jqhover: x.hover_ }"
            @mouseenter="x.hover_ = true"
            @mouseleave="leaveItem1()"
          >
            <div class="img1" v-show="x.hover_">
              <span></span>
            </div>
            <div class="info">{{ x.info }}</div>
            <div class="img2" v-show="x.hover_">
              <span></span>
            </div>
            <div class="logo" v-show="!x.hover_">
              <img :src="x.logo" alt="" />
            </div>
            <div class="person" v-show="x.hover_">—{{ x.person }}</div>
          </li>
        </ul>
      </div>
    </div>
    <lun-bo></lun-bo>
    <div class="item_2">
      <div class="item-title">
        <h3 class="title2">全国各地都在使用易知鸟</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <div class="map"></div>
      </div>
    </div>
    <shen-qing></shen-qing>
  </div>
</template>

<script>
import lunBo from "./lunbo.vue";
import shenQing from "./shenqing.vue";
export default {
  components: {
    lunBo,
    shenQing
  },
  data() {
    return {
      item1_list: [
        {
          person: "小天鹅创始人 胡雪",
          logo: "static/img/common/logo/lang/1.png",
          info:
            "易知鸟的可贵之处在于，功能上十分丰富，而在操作上又十分简洁。人性化的产品交互逻辑，可以帮助行政人员大大提升工作效率。易知鸟系统满足了机构转型升级的需求，将成为机构实现数字化、信息化的有力工具。"
        },
        {
          person: "宁方舞蹈创始人 张丁方",
          logo: "static/img/common/logo/lang/2.png",
          info:
            "易知鸟的统计分析功能为我们直观展示了机构的销售、教务、财务等数据，为我们做决策提供了强大的数据支持，帮助我们做出更清晰准确的决策。"
        },
        {
          person: "小童星创始人 潘丽群",
          logo: "static/img/common/logo/lang/3.png",
          info:
            "易知鸟对于教育机构的认知和我们比较吻合，所以在产品功能、落地使用场景等方面和我们很契合，特别是在跨校区管理方面，很有想法，又很落地，引领我们提高跨校区管理水平。"
        },
        {
          person: "葛道围棋创始人 葛玉宏",
          logo: "static/img/common/logo/lang/4.png",
          info:
            "使用易知鸟系统以来，机构在招生、教务、课务、行政管理等方面都得到了极大改善，老师们在手机上就可以完成很多工作，很实用，孩子们和家长对机构的满意度达到95%。"
        },
        {
          person: "天鹅国际副总裁 杨小峰",
          logo: "static/img/common/logo/lang/5.png",
          info:
            "易知鸟为机构和家长建立起了沟通桥梁，我们与家长、学员无缝连接，拉进了我们和家长之间的距离，更精准地把握学员学习动向，从而更好地帮助学员成长，机构的续费率提升了30%。"
        },
        {
          person: "口才宝杭州总校长 赵李",
          logo: "static/img/common/logo/lang/6.png",
          info:
            "我们使用易知鸟系统三年了，易知鸟的功能操作简单易学，老师们用了之后纷纷表示很实用，我们在3天内完成了1000+学员的续费、缴费、登记、收据打印、发放全过程，大大提升了工作效率。"
        },
        {
          person: "舞维一体创始人 舒俊",
          logo: "static/img/common/logo/lang/7.png",
          info:
            "数字化、信息化是机构的未来趋势，易知鸟系统满足了我们对机构转型升级的需求，为我们的5家直营店、29家加盟店以及数万名学员提供了专业的系统服务，全面提升了我们的竞争力。"
        },
        {
          person: "中邮艺术团创始人 胡宇",
          logo: "static/img/common/logo/lang/8.png",
          info:
            "易知鸟是专注为校外培训机构量身打造的教务管理系统，因为更懂机构，所以对提升机构运营管理效率、加快实现规范化教学有非常大的帮助。"
        },
        {
          person: "舞动七彩光创始人 付付",
          logo: "static/img/common/logo/lang/9.png",
          info:
            "用易知鸟系统三年了，不仅提升了我们的招生、教务、家校沟通等能力，还为我们提供了不少优质教育资源，慢慢成了我们的“左膀右臂”。接下来，我们会继续选择易知鸟，我相信在教育这条路上，有易知鸟的支持，舞动七彩光一定会发展得更好。"
        }
      ]
    };
  },
  created() {
    this.item1_list.map((item, i) => {
      this.$set(item, "hover_", false);
    });
  },
  mounted() {},
  methods: {
    leaveItem1() {
      this.item1_list.map((item, i) => {
        this.$set(item, "hover_", false);
      });
    },
    openDialog: function(title, type) {
      //type:(0机构,1微官网)
      this.$parent.$refs.openPop.openDialog(title, type);
    }
  }
};
</script>

<style scoped lang="less">
.banner {
  width: 100%;
  height: 700px;
  background: url("https://cdntest.yizhiniao.com/newWebsite_/customer/banner_1_801.png")
    no-repeat center;

  .banner-center {
    height: 100%;
    position: relative;
  }

  .banner-info {
    position: absolute;
    bottom: 130px;
    width: 100%;
    .btn {
      margin: 0 auto;
    }
  }
}
.item_1 {
  padding-top: 90px;
  .item-contents {
    padding: 120px 0 180px;
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 1120px;
      height: 1590px;
      margin: 0 auto;
      > li {
        width: 348px;
        height: 448px;
        border-radius: 4px;
        border: 1px solid #ffabad;
        padding: 60px 25px 50px;
        position: relative;
        color: #646464;
        font-size: 16px;
        line-height: 32px;
        &.jqhover {
          border: none;
          box-shadow: 0px 2px 30px 0px #dfe4ea;
          padding: 25px 25px 60px;
          color: #1e1e1e;
          .img1 {
            text-align: left;
          }
          .img2 {
            text-align: right;
          }
          .img1 span,
          .img2 span {
            width: 24px;
            height: 35px;
          }
          .img1 span {
            background: url("https://cdntest.yizhiniao.com/newWebsite_/customer/img1.png")
              no-repeat center;
          }
          .img2 span {
            background: url("https://cdntest.yizhiniao.com/newWebsite_/customer/img2.png")
              no-repeat center;
          }
          .person {
            bottom: 60px;
          }
        }
        .info {
          text-align: left;
        }
        .logo {
          position: absolute;
          bottom: 50px;
          margin: 0 auto;
          max-width: 280px;
          max-height: 150px;
        }
        .person {
          position: absolute;
          bottom: 50px;
          right: 25px;
        }
      }
    }
  }
}
.item_2 {
  padding-top: 180px;
  .item-contents {
    padding: 0 0 56px;
  }
  .map {
    width: 986px;
    height: 796px;
    margin: 79px auto 0;
    background: url("https://cdntest.yizhiniao.com/newWebsite_/customer/ditu.jpg")
      no-repeat center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer.vue